/*
 * Copyright (c) 2021 LNBIG.com
 * All rights reserved.
 */

import dbg from "debug"
const debug = dbg('lnbig:mixin:copy')

export default {
    methods: {
        copy: function (name, value) {
            this.$copyText(value).then(
                e => {
                    if (this.$snackBar) {
                        this.$snackBar.color = 'success'
                        this.$snackBar.timeout = 1700
                        this.$snackBar.text = `${name} was copied!`
                        this.$snackBar.show = true
                    }
                },
                function () {
                    this.showSnackError(`Copy error of ${name}!`)
                }
            )
        },
    },
}
